export const consumption = (
  current: number,
  previous: number,
  factor: number
) => {
  if (previous > current) {
    const diff = 100000 - previous;
    return (current + diff) * factor;
  }
  return (current - previous) * factor;
};
